import React, { useState, useEffect } from "react";
import ProphetBirthdayBanner from "./ProphetBirthdayBanner";
import styles from "./Loading.module.css";

export default function Loading({ onLoadingComplete }) {
  const [progress, setProgress] = useState(0);
  const [currentText, setCurrentText] = useState(0);
  const [showBanner, setShowBanner] = useState(false);
  const [loadingComplete, setLoadingComplete] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isPreparingBanner, setIsPreparingBanner] = useState(false);

  const loadingTexts = [
    "جاري تحميل المنصة التعليمية...",
    "إعداد المحتوى التعليمي...",
    "تحميل الدورات التدريبية...",
    "إعداد المدرسين...",
    "تقريباً انتهينا...",
  ];

  useEffect(() => {
    // Simulate loading progress
    const progressTimer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressTimer);
          return 100;
        }
        return prev + 2;
      });
    }, 50);

    // Change loading text
    const textTimer = setInterval(() => {
      setCurrentText((prev) => {
        if (prev >= loadingTexts.length - 1) {
          clearInterval(textTimer);
          return loadingTexts.length - 1;
        }
        return prev + 1;
      });
    }, 1000);

    return () => {
      clearInterval(progressTimer);
      clearInterval(textTimer);
    };
  }, []);

  useEffect(() => {
    if (progress === 100) {
      // التحقق من sessionStorage قبل عرض البانر فوراً بدون تأخير
      const bannerShown = sessionStorage.getItem("prophetBirthdayBannerShown");

      // التحقق من أن المناسبة لم تنتهي بعد
      const eidMiladDate = new Date("2025-09-04T00:00:00");
      const now = new Date();
      const isEventStillActive = now < eidMiladDate;

      if (!bannerShown && isEventStillActive) {
        // إضافة تأخير قصير لضمان عدم وجود صفحة بيضاء
        setIsPreparingBanner(true);
        setTimeout(() => {
          setShowBanner(true);
          setIsPreparingBanner(false);
        }, 50);
      } else {
        // إذا كان البانر قد تم عرضه من قبل أو انتهت المناسبة، اعرض الموقع مباشرة
        console.log(
          "Banner already shown or event ended, proceeding to main site"
        );
        setIsTransitioning(true);
        setTimeout(() => {
          setLoadingComplete(true);
          if (onLoadingComplete) {
            onLoadingComplete();
          }
        }, 100); // تأخير قصير جداً للانتقال السلس
      }
    }
  }, [progress, onLoadingComplete]);

  const handleBannerClose = () => {
    console.log("handleBannerClose called");
    setShowBanner(false);
    setIsTransitioning(true);
    setTimeout(() => {
      setLoadingComplete(true);
      console.log("Calling onLoadingComplete");
      if (onLoadingComplete) {
        onLoadingComplete();
      }
    }, 100); // تأخير قصير للانتقال السلس
  };

  // إذا انتهى اللودنج ولم يتم عرض البانر، اعرض الموقع مباشرة
  useEffect(() => {
    if (
      progress === 100 &&
      !showBanner &&
      !loadingComplete &&
      !isTransitioning
    ) {
      const timer = setTimeout(() => {
        console.log(
          "Loading complete, no banner to show, proceeding to main site"
        );
        setIsTransitioning(true);
        setTimeout(() => {
          setLoadingComplete(true);
          if (onLoadingComplete) {
            onLoadingComplete();
          }
        }, 100);
      }, 500); // تقليل الانتظار إلى نصف ثانية فقط

      return () => clearTimeout(timer);
    }
  }, [
    progress,
    showBanner,
    loadingComplete,
    isTransitioning,
    onLoadingComplete,
  ]);

  if (loadingComplete) {
    return null;
  }

  return (
    <>
      {/* خلفية مؤقتة لمنع الصفحة البيضاء */}
      {(isTransitioning ||
        isPreparingBanner ||
        (progress === 100 && !showBanner && !loadingComplete)) && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "#f8f9fa",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              textAlign: "center",
              color: "#333",
              fontSize: "18px",
            }}
          >
            جاري التحميل...
          </div>
        </div>
      )}

      {!showBanner &&
        !loadingComplete &&
        !isTransitioning &&
        !isPreparingBanner && (
          <div className={styles.loadingOverlay}>
            <div className={styles.loadingContainer}>
              <div className={styles.logoContainer}>
                <img
                  src="/assets/imgs/Frame 1410103777.svg"
                  alt="Logo"
                  className={styles.logo}
                />
                <h1 className={styles.platformName}>منصة تميز التعليمية</h1>
              </div>

              <div className={styles.progressContainer}>
                <div className={styles.progressBar}>
                  <div
                    className={styles.progressFill}
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
                <div className={styles.progressText}>{progress}%</div>
              </div>

              <div className={styles.loadingText}>
                <span className={styles.textAnimation}>
                  {loadingTexts[currentText]}
                </span>
                <div className={styles.loadingAnimation}>
                  <span className={styles.dot}>.</span>
                  <span className={styles.dot}>.</span>
                  <span className={styles.dot}>.</span>
                </div>
              </div>
            </div>
          </div>
        )}

      {showBanner && !loadingComplete && (
        <ProphetBirthdayBanner onClose={handleBannerClose} />
      )}
    </>
  );
}
